<template>
  <v-dialog
    v-model="show"
    max-width="650"
    class="update-recharge-link-modal"
    scrollable
    persistent
  >
    <v-card>
      <v-card-title>
        <h4 class="mb-1">Update Recharge Link</h4>
      </v-card-title>

      <v-divider class="mb-5" />

      <v-card-text class="my-3">
        <p class="mb-4 text-body-2">
          Enter the email address which was used when purchasing their
          subscription
        </p>

        <v-text-field
          v-model="form.email"
          :disabled="form.$busy"
          :error-messages="form.$getError('email')"
          :rules="emailRules"
          label="Email Address"
          type="email"
          outlined
          flat
          placeholder="example@email.com"
        />
      </v-card-text>

      <v-divider class="mb-3" />

      <v-card-actions class="px-5 pb-5">
        <v-spacer />

        <v-btn
          color="primary"
          :loading="form.$busy"
          @click="show = false"
          outlined
          rounded
        >
          Cancel
        </v-btn>

        <v-btn
          color="secondary"
          :loading="form.$busy"
          :disabled="!form.email || !isEmailValid"
          @click="updateRechargeLink"
          rounded
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Form from '@/utils/form'

export default {
  name: 'UpdateRechargeLink',

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      show: this.value,
      form: new Form({
        email: '',
      }),
      emailRules: [
        (v) => !!v || 'Email is required',
        (v) => /.+@.+\..+/.test(v) || 'Email must be valid',
      ],
    }
  },

  computed: {
    isEmailValid() {
      return /.+@.+\..+/.test(this.form.email)
    },
  },

  methods: {
    async updateRechargeLink() {
      this.form.$busy = true
      this.form.$clearErrors()

      const userId = this.$route.params.id

      await this.$api
        .post(`users/${userId}/update-recharge-link`, {
          old_email: this.form.email,
        })
        .then(({ data }) => {
          setTimeout(() => {
            this.form.$busy = false
            this.show = false
            this.$emit('reloadMembershipHistory')
            // Show success message if you have a notification system
            // this.$notify({ type: 'success', message: 'Recharge link updated successfully' })
          }, 600)
        })
        .catch(({ response }) => {
          setTimeout(() => {
            this.form.$busy = false

            if (response && response.data && response.data.message) {
              this.form.$setErrors({ email: [response.data.message] })
            }
          }, 600)
        })
    },
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.$emit('input', val)

      if (!val) {
        this.form.$reset()
      }
    },
  },
}
</script>
